import React from 'react';
import styled from 'styled-components';
import { CheckCircle } from '@styled-icons/boxicons-regular';
import { Block } from '@styled-icons/boxicons-regular';
import { ErrorCircle } from '@styled-icons/boxicons-regular';

const CheckList = styled(CheckCircle)`
  color: blue;
  height: 1rem;
  width: 1rem;
`;

const SuccessIcon = styled(CheckCircle)`
  color: green;
  height: 2.5rem;
  width: 2.5rem;
`;

const RetryIcon = styled(Block)`
  height: 2.5rem;
  width: 2.5rem;
  color: red;
`;

const InfoIcon = styled(ErrorCircle)`
  color: blue;
  height: 2.5rem;
  width: 2.5rem;
`;

const IconsGroup = {
  SuccessIcon,
  RetryIcon,
  InfoIcon,
  CheckList
};

function Icons({ icon }) {
  return React.createElement(IconsGroup[icon]);
}

export default Icons;
